<template>
  <layout-simple :title="$t('views.Error.title')">
    <v-container class="mx-auto">
      <v-row align="center" class="ma-auto">
        <v-card class="ma-auto" flat align="center">
          <v-card-text>
            {{ $t("views.NoRoles.title") }}<br />
            {{ $t("views.NoRoles.subtitle") }}
          </v-card-text>
        </v-card>
      </v-row>
    </v-container>
    <v-container class="mx-auto">
      <v-row align="center" class="ma-auto">
        <v-card class="ma-auto" flat align="center">
          <v-card-actions>
            <v-btn @click="sendMail" flat outlined text>
              {{ $t("views.NoRoles.sendMail") }}
            </v-btn>
            <v-btn @click="backToLogin" flat outlined text>
              {{ $t("views.NoRoles.backToLogin") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-row>
    </v-container>
  </layout-simple>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import Card from "@/components/utility/Card.vue";
import LayoutSimple from "@/layouts/LayoutSimple.vue";
import { ConfigModule } from "@/store/modules/config";
import Tooltip from "@/components/utility/tooltip.vue";
import ErrorList from "@/components/utility/ErrorList.vue";
import { UserModule } from "@/store/modules/me-user.store";

@Component({
  components: {
    Card,
    LayoutSimple,
    Tooltip,
    ErrorList
  }
})
export default class NoRoles extends Vue {
  sendMail() {
    const mailText = `mailto:${ConfigModule.supportMail}`;

    window.open(mailText, "_blank");
  }

  backToLogin() {
    this.$router.push({ path: "/login" });
  }

  mounted() {
    UserModule.deactivateTokens();
    UserModule.removeUserTokens();
  }
}
</script>
